import { render } from "./unionScreen.vue?vue&type=template&id=1566112a&scoped=true"
import script from "./unionScreen.vue?vue&type=script&lang=js"
export * from "./unionScreen.vue?vue&type=script&lang=js"

import "./unionScreen.vue?vue&type=style&index=0&id=1566112a&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1566112a"]])

export default __exports__